import { makeStyles } from '@mui/styles'

// TODO: potential refactor?
const useStyles = makeStyles(theme => ({
  chartWrapper: {
    position: 'relative',
  },
  chart: {
    width: theme.spacing(61),
    height: theme.spacing(35),
  },
  chartText: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    left: theme.spacing(8.75),
    width: theme.spacing(15.5),
    height: theme.spacing(15.5),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    '&:after': {
      left: '50%',
      transform: 'translateX(-50%)',
    },
  },
  subtitle: {
    marginTop: theme.spacing(1),
    color: theme.palette.neutral.main,
  },
}))

export default useStyles
